import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { CheckCircle2, XCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function VerifyEmail() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = new URLSearchParams(window.location.search).get('token') || '';
    (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/auth/verify-email`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
        });
        setStatus(res.ok ? 'success' : 'fail');
      } catch {
        setStatus('fail');
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ background: '#050505' }} data-testid="verify-email-page">
      <motion.div
        className="w-full max-w-md rounded-3xl border border-white/10 p-10 text-center"
        style={{ background: 'radial-gradient(ellipse at 50% -20%, rgba(226,193,121,0.1) 0%, #0a0a0a 60%)' }}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        {status === 'verifying' && (
          <div data-testid="verify-loading">
            <div className="relative w-10 h-10 mx-auto mb-5">
              <div className="absolute inset-0 rounded-full border-2 border-white/10" />
              <div className="absolute inset-0 rounded-full border-2 border-transparent animate-spin" style={{ borderTopColor: '#e2c179' }} />
            </div>
            <p className="text-sm text-gray-400">...</p>
          </div>
        )}
        {status === 'success' && (
          <div data-testid="verify-success">
            <CheckCircle2 size={44} className="mx-auto mb-5" style={{ color: '#4ade80' }} />
            <h1 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Syne', sans-serif" }}>{t('verifyTitle')}</h1>
            <p className="text-sm text-gray-400 mb-8">{t('verifyText')}</p>
            <button className="btn-accent" onClick={() => navigate('/dashboard')} data-testid="verify-dashboard-btn">
              {t('verifyGoDashboard')}
            </button>
          </div>
        )}
        {status === 'fail' && (
          <div data-testid="verify-fail">
            <XCircle size={44} className="mx-auto mb-5" style={{ color: '#f87171' }} />
            <h1 className="text-2xl font-bold text-white mb-3" style={{ fontFamily: "'Syne', sans-serif" }}>{t('verifyFailTitle')}</h1>
            <p className="text-sm text-gray-400 mb-8">{t('verifyFailText')}</p>
            <button className="btn-outline" onClick={() => navigate('/dashboard')} data-testid="verify-dashboard-btn">
              {t('verifyGoDashboard')}
            </button>
          </div>
        )}
      </motion.div>
    </div>
  );
}
